/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-02-25 09:44:01
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/outFishProfitGroup/searchOutFishProfitGroupList`
  return http.post(url, data)
}

// 获取所有区域--单位利润计划与实际比
export function getAllJiGou(data){
  const url = `/outFishProfitGroup/getGroupConditions`
  return http.post(url,data)
}

// 获取所有造次--单位利润计划与实际比
export function getAllPiCi(data){
  const url = `/outFishProfitGroup/getPeriodConditions`
  return http.post(url,data)
}
// 获取所有品类--单位利润计划与实际比
export function getAllPinLei(data){
  const url = `/outFishProfitGroup/getTypeConditions`
  return http.post(url,data)
}
// 获取所有品种--单位利润计划与实际比
export function getAllPinZhong(data){
  const url = `/outFishProfitGroup/getBreedConditions`
  return http.post(url,data)
}

